import type { Canvas } from "fabric";
import { useOn } from "../../../../../../hooks/useOn.ts";

export const useCanvasDeleteKeyboardShortcut = ({
  fabricCanvas,
  isDeletionDisabled,
  onDelete,
}: {
  fabricCanvas?: Canvas;
  isDeletionDisabled: boolean;
  onDelete: () => void;
}) => {
  useOn("keydown", ({ key }) => {
    if (fabricCanvas === undefined) return;
    if (key === "Delete" || key === "Backspace") {
      if (isDeletionDisabled) return;
      onDelete();
    }
  });
};
